import _implicitStylesheets from "./messageBox.css";
import _implicitScopedStylesheets from "./messageBox.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _i18nLink from "i18n/link";
import _axIconInteractive from "ax/iconInteractive";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "notification-content": true
  },
  key: 1
};
const stc1 = {
  attrs: {
    "grid": "",
    "axis": "column"
  },
  key: 3
};
const stc2 = {
  classMap: {
    "notification-title": true
  },
  key: 4
};
const stc3 = {
  classMap: {
    "notification-text": true
  },
  key: 6
};
const stc4 = {
  "close-button": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, h: api_element, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.cssNotificationClass),
    attrs: {
      "role": "alertdialog",
      "aria-label": $cmp.dialogAriaLabel
    },
    key: 0
  }, [api_element("div", stc0, [api_custom_element("ax-icon", _axIcon, {
    props: {
      "icon": $cmp.iconProperties.icon,
      "theme": $cmp.iconProperties.theme,
      "iconDescription": $cmp.iconProperties.iconDescription
    },
    key: 2
  }), api_element("div", stc1, [$cmp.title ? api_element("div", stc2, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.title,
      "target": "_blank"
    },
    key: 5
  })]) : null, api_element("div", stc3, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.message,
      "target": "_blank"
    },
    key: 7
  })])])]), !$cmp.hideCloseButton ? api_custom_element("ax-icon-interactive", _axIconInteractive, {
    classMap: stc4,
    props: {
      "iconDescription": $cmp.closeButtonAriaLabel,
      "icon": "close",
      "size": "xsmall",
      "transparentBackground": "true"
    },
    key: 8,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClose))
    }
  }) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3jjbtgpri7n";
tmpl.legacyStylesheetToken = "undefined-_messageBox";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
